<template>
    <client-page class="wrap--sub">
        <div class="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">이벤트</h2>
                </div>

                <router-view name="board" code="event" skin="gallery" hide-write-button></router-view>

            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
};
</script>
